module.exports = __webpack_public_path__ + "img/full-na-1.67d79eeb.jpg";